/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/navigation/navigationQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useGetHomeOptionsQuery, useGetUserHomeKeyQuery } from '../../../__generated__/chirp/com/hubspot/nav/config/rpc/NavConfigHomeService.hooks';
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/navigation/navigationQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useHomeOptions = () => {
  const {
    data,
    loading: homeOptionsLoading,
    error: homeOptionsError
  } = useGetHomeOptionsQuery();
  return {
    homeOptions: data === null || data === void 0 ? void 0 : data.homeOptions,
    homeOptionsLoading,
    homeOptionsError
  };
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/navigation/navigationQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useHomeKey = () => {
  const {
    data,
    loading: homeKeyLoading,
    error: homeKeyError
  } = useGetUserHomeKeyQuery();
  return {
    homeKey: data === null || data === void 0 ? void 0 : data.homeKey,
    homeKeyLoading,
    homeKeyError
  };
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/navigation/navigationQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useHomepageUrl = () => {
  var _foundOption$path;
  const {
    homeOptions,
    homeOptionsLoading,
    homeOptionsError
  } = useHomeOptions();
  const {
    homeKey,
    homeKeyLoading,
    homeKeyError
  } = useHomeKey();
  let overridableHomeKey = homeKey;
  if (!homeKey || homeKey === 'academy') {
    overridableHomeKey = 'dashboards';
  }
  const foundOption = homeOptions && homeOptions.find(option => option && (option.id === overridableHomeKey || option.id === 'dashboards' || option.id === 'global-home'));
  return {
    homepage: (_foundOption$path = foundOption === null || foundOption === void 0 ? void 0 : foundOption.path) !== null && _foundOption$path !== void 0 ? _foundOption$path : null,
    homepageLoading: homeOptionsLoading || homeKeyLoading,
    homepageError: homeOptionsError || homeKeyError
  };
};